import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-white p-5 mb-4 flex flex-col" }
const _hoisted_2 = { class: "course-title text-lg font-bold text-h-neutral-900 mb-2" }
const _hoisted_3 = { class: "text-xs text-h-neutral-700" }
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = { class: "text-sm font-bold ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("labels.generic", {
          pt: "Andamento do curso",
          en: "Progress course",
        })), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", {
          pt: "Progresso",
          en: "Progress",
        })), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ProgressBar, {
        class: "progressbar-style w-full",
        style: {"height":"8px"},
        value: _ctx.storeChapter.percentages.coursePercentage,
        "show-value": false
      }, null, 8, ["value"]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.storeChapter.percentages.coursePercentage) + "%", 1)
    ])
  ]))
}